import { Component, computed, inject, input } from '@angular/core';

import {
  BoelsUserTypeEnum,
  BOProduct,
  ProductType,
  StorageKey,
} from '@boels/models';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from '@boels/helpers';

@Component({
  selector: 'boels-product-price',
  imports: [TranslocoModule, FaIconComponent, NgbTooltip],
  templateUrl: './product-price.component.html',
  styleUrl: './product-price.component.scss',
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: ['productGrid', 'productDetails'],
    },
  ],
})
export class ProductPriceComponent {
  localstorageService = inject(LocalStorageService);
  product = input.required<BOProduct>();
  type = input.required<ProductType>();
  userType = input<BoelsUserTypeEnum>(
    this.localstorageService.getItem(StorageKey.USER_TYPE) as BoelsUserTypeEnum,
  );
  vatLabel = computed(() => {
    switch (this.userType()) {
      case BoelsUserTypeEnum.BUSINESS:
      case BoelsUserTypeEnum.REGISTERED:
        return 'productGrid.labelExclVat';
      case BoelsUserTypeEnum.INDIVIDUAL:
      default:
        return 'productGrid.labelInclVat';
    }
  });

  prices = computed(() => {
    const unitPrices = this.product().unitPrices;
    if (!unitPrices) return [];

    const isBusinessOrRegistered =
      this.userType() === BoelsUserTypeEnum.BUSINESS ||
      this.userType() === BoelsUserTypeEnum.REGISTERED;

    return unitPrices.filter((price) =>
      isBusinessOrRegistered ? price.netPrice : !price.netPrice,
    );
  });

  protected readonly faCircleInfo = faCircleInfo;
}
